import { render, staticRenderFns } from "./AdComponent.vue?vue&type=template&id=0321ecfa&scoped=true&"
import script from "./AdComponent.vue?vue&type=script&lang=js&"
export * from "./AdComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdComponent.vue?vue&type=style&index=0&id=0321ecfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321ecfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
